import { Select } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div<{ height?: string; width?: string }>`
  display: flex;
  align-items: center;
  width: ${p => p.width || '230px'};
  height: ${p => p.height || '42px'};
  border: 1px solid ${props => props.theme.colors.border.main};
  background: #fff;
  border-radius: ${props => props.theme.radius.md};
  padding-left: 12px;
`;

export const CSelect = styled(Select)<{ height?: string; width?: string }>`
  width: ${p => p.width || '230px'};
  height: 100%;
  .ant-select-selector {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;

    display: flex;
    align-items: center;
    ${p => p.height && `height: 100% !important;`}

    .ant-select-selection-search-input {
      ${p => p.height && `height: 100% !important;`}
      ${p => p.height && `line-height: ${p.height};`}
    }

    .ant-select-selection-placeholder {
      ${p => p.height && `line-height: ${p.height};`}
      font-weight: ${p => p.theme.font.weight.regular} !important;
    }

    .ant-select-selection-item {
      display: flex;
      align-items: center;
    }
    &:active {
      outline: none !important;
      box-shadow: none !important;
      border: 0 !important;
    }
  }
`;
